module.exports = __webpack_public_path__ + "images/花筑奢pr长图_04-6.jpg?v=a77f5328";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_04-6.jpg
 ** module id = 35
 ** module chunks = 1 2
 **/